import {useParams} from 'react-router-dom'

export function useProposalLink() {
  const {randomId} = useParams()
  return {randomId}
}
